import { createContext, useState } from 'react';


export const SnackBarContext = createContext<any>(null);

interface SnackBarType{
    status:string,
    title:string,
    isActive:boolean
}

export const SnackBarProvider = ({ children }:any) => {
    const [isSnackBar, setSnackBarOpen] = useState<SnackBarType>({
        status:'error',
        title:'',
        isActive:false
    });

    const setSnackBar = (moduleState: SnackBarType)=> {
        setSnackBarOpen(moduleState);
    };

    return (
        <SnackBarContext.Provider
            value={{
                isSnackBar,
                setSnackBar,
            }}>
            {children}
        </SnackBarContext.Provider>
    );
};
